export const PPT_PROCESSED = "PROCESSED";
export const PPT_UNPROCESSED = "UNPROCESSED";
export const PPT_PENDING = "PENDING";
export const PPT_INPROCESS = "INPROCESS";
export const PPT_READYTOPROCESS = "READYTOPROCESS";
export const PPT_PROCESSING = "PROCESSING";
export const PPT_AZUREFAIL = "ERRORINPICKUP";
export const PPT_ERROR = "ERROR";
